<template>
  <AtlasButton
    v-if="isSupported"
    :title="isCopied ? t('Link Copied') : t('Copy link')"
    class="secondary"
    :icon="isCopied ? 'common/checkmark' : 'common/content_copy'"
    popovertarget="copy-link-popover"
    @click="handleCopy"
  />
</template>
<script setup lang="ts">
import { useClipboard } from '@vueuse/core';
import { AtlasButton } from '@nhst/ui';
const { t } = useI18n();
const urlRequest = useRequestURL();
const utmConfig = useRuntimeConfig().public.utm;

const urlWithTracker = `${urlRequest.origin}${urlRequest.pathname}?utm_source=${utmConfig.source}&utm_medium=${utmConfig.medium}&utm_campaign=${utmConfig.campaign}`;
const { copy, isSupported } = useClipboard();
const isCopied = ref(false);

const handleCopy = async () => {
  await copy(urlWithTracker);
  isCopied.value = true;
};
</script>
